import { useEffect, useState } from "react";
import { api } from "@/lib/api";
export const ALLIN_GIFTS = [
  { id: "kiss", name: "Herz mit Handkuss", art: "ein Herz mit Handkuss", emoji: "💋", tone: "from-rose-400 via-pink-500 to-fuchsia-500" },
  { id: "lion", name: "Miauender Löwe", art: "einen miauenden Löwen", emoji: "🦁", tone: "from-amber-300 via-orange-400 to-rose-500" },
  { id: "stars", name: "Sternenregen", art: "einen Sternenregen", emoji: "🌟", tone: "from-indigo-400 via-fuchsia-500 to-amber-300" },
];
export const giftById = (id) => ALLIN_GIFTS.find((g) => g.id === id) || ALLIN_GIFTS[0];

let CFG = { cost: 500, reward: 100 };
let req = null;
export function useGiftCfg() {
  const [cfg, setCfg] = useState(CFG);
  useEffect(() => {
    req = req || api.get("/allin/config").then(({ data }) => { CFG = data; return data; }).catch(() => CFG).finally(() => setTimeout(() => { req = null; }, 30000));
    req.then(setCfg);
  }, []);
  return cfg;
}
